export const REGISTER_OPTIONS: { value: boolean; label: string }[] = [
  { value: true, label: 'Settings::PhoneNumbers:Yes' },
  { value: false, label: 'Settings::PhoneNumbers:No' },
];
